{
  "_provenance": {
    "ns": "dashboard",
    "source": "the parent home: pages/DashboardPage.tsx and lib/{parent-home-greeting,parent-home-noticing,dashboard-mode}.ts (#2109 R3 lane L1)"
  },
  "checkins": {
    "answer": "Answer",
    "answerAria": "Answer {{title}}",
    "dialogDescription": "Your answers go to TRF.",
    "due": "Due {{day}}",
    "heading": "For you to answer",
    "kind": {
      "checkin": "Check-in",
      "custom": "Form from TRF"
    }
  },
  "chips": {
    "askCompanion": "Ask {{companion}} something",
    "logChild": "Log how your child is doing",
    "logMedication": "Log a medication",
    "questionsFor": "Questions for {{provider}}",
    "questionsForDoctor": "Questions for the doctor",
    "todosWaiting_one": "{{count}} to-do waiting",
    "todosWaiting_other": "{{count}} to-dos waiting",
    "visitCommunity": "See announcements"
  },
  "composer": {
    "ariaLabel": "Ask {{companion}}",
    "placeholder": "Ask {{companion}} anything…"
  },
  "greeting": {
    "afternoon": "Good afternoon, <emphasis>{{name}}</emphasis>.",
    "afternoonAlone": "Good afternoon.",
    "evening": "Good evening, <emphasis>{{name}}</emphasis>.",
    "eveningAlone": "Good evening.",
    "hello": "Hello, <emphasis>{{name}}</emphasis>.",
    "helloAlone": "Hello.",
    "morning": "Good morning, <emphasis>{{name}}</emphasis>.",
    "morningAlone": "Good morning."
  },
  "noticing": {
    "appointment": {
      "cta": "Draft questions with {{companion}}",
      "onDay": "{{title}} is on {{weekday}}. Want help drafting questions for {{provider}}?",
      "onDayDoctor": "{{title}} is on {{weekday}}. Want help drafting questions for the doctor?",
      "prompt": "Help me draft a few questions for {{provider}} for {{title}}.",
      "promptDoctor": "Help me draft a few questions for the doctor for {{title}}.",
      "today": "{{title}} is today. Want help drafting questions for {{provider}}?",
      "todayDoctor": "{{title}} is today. Want help drafting questions for the doctor?",
      "tomorrow": "{{title}} is tomorrow. Want help drafting questions for {{provider}}?",
      "tomorrowDoctor": "{{title}} is tomorrow. Want help drafting questions for the doctor?"
    },
    "overdue": {
      "body_one": "{{count}} to-do is overdue.",
      "body_other": "{{count}} to-dos are overdue.",
      "prompt_one": "Help me sort out my overdue to-do.",
      "prompt_other": "Help me sort out my overdue to-dos."
    },
    "paid": {
      "body": "TRF paid {{amount}} on {{date}}.",
      "prompt": "Help me understand my grant payments."
    },
    "polls": {
      "body_one": "TRF is asking you {{count}} question.",
      "body_other": "TRF is asking you {{count}} questions.",
      "prompt": "What is TRF asking me?"
    },
    "receipts": {
      "body_one": "{{count}} receipt needs you.",
      "body_other": "{{count}} receipts need you.",
      "prompt_one": "Help me finish the receipt TRF needs from me.",
      "prompt_other": "Help me finish the receipts TRF needs from me."
    },
    "renewal": {
      "due": "Your Signature Grant is in its final months. It is time to renew.",
      "inProgress": "Your renewal is underway.",
      "inProgressYear": "Your {{year}} renewal is underway.",
      "needsInfo": "TRF needs something from you for your renewal.",
      "needsInfoItems": "TRF needs something from you for your renewal: {{items}}.",
      "prompt": "Help me with my grant renewal."
    }
  },
  "states": {
    "loadErrorBody": "Please refresh the page or try again later.",
    "loadErrorTitle": "Couldn’t load your home",
    "loading": "Loading…"
  }
}
